import { JsonSchemaValidator } from "@common/json-schema-validator";
import { OverlayHeight, OverlayUrl, OverlayWidth } from "../../interface";
import { overlayHeight, overlayUrl, overlayWidth } from "../../schema";

export class MixerOverlaySetCmd {
  private static validation = JsonSchemaValidator.compile(
    MixerOverlaySetCmd.validationSchema()
  );

  readonly value: MixerOverlaySet;

  constructor(value: MixerOverlaySet) {
    this.value = JsonSchemaValidator.assert(
      MixerOverlaySetCmd.validation,
      value
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["overlayUrl", "overlayWidth", "overlayHeight"],
      properties: {
        overlayUrl,
        overlayWidth,
        overlayHeight
      },
      additionalProperties: false
    };
  }
}

interface MixerOverlaySet {
  overlayUrl: OverlayUrl;
  overlayWidth: OverlayWidth;
  overlayHeight: OverlayHeight;
}
